import { isRetryableRequestError } from './requestErrorMessage';

export const WALLET_RETRY_DELAYS_MS = [800, 2000];

export function pickCardPayload(data) {
  if (!data) {
    return null;
  }
  if (data.url) {
    return data;
  }
  return data[0] || (data.data && data.data[0]) || null;
}

function defaultSleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

async function readExistingCard(fetchCard) {
  const listed = await fetchCard();
  const existing = pickCardPayload(listed);
  if (existing && existing.url) {
    return existing;
  }
  return null;
}

export async function issueWalletCardWithRetry({
  createCard,
  fetchCard,
  isCardExists,
  sleep = defaultSleep,
  retryDelaysMs = WALLET_RETRY_DELAYS_MS,
}) {
  let lastError = null;
  const attempts = retryDelaysMs.length + 1;

  for (let i = 0; i < attempts; i += 1) {
    try {
      const created = await createCard();
      const card = pickCardPayload(created);
      if (card && card.url) {
        return card;
      }
      const existing = await readExistingCard(fetchCard);
      if (existing) {
        return existing;
      }
    } catch (err) {
      lastError = err;
      if (isCardExists(err)) {
        try {
          const existing = await readExistingCard(fetchCard);
          if (existing) {
            return existing;
          }
        } catch (getErr) {
          lastError = getErr;
        }
      } else if (
        err.status === 502
        || err.status === 503
        || err.status === 504
      ) {
        // Google already used the timeout. Another POST repeats that wait.
        // One GET still picks up a card the server managed to save.
        try {
          const existing = await readExistingCard(fetchCard);
          if (existing) {
            return existing;
          }
        } catch (getErr) {
          lastError = getErr;
        }
        throw err;
      } else if (!isRetryableRequestError(err)) {
        throw err;
      } else {
        // POST may have finished on the server after Safari dropped the
        // connection (TypeError: Load failed).
        try {
          const existing = await readExistingCard(fetchCard);
          if (existing) {
            return existing;
          }
        } catch (getErr) {
          lastError = lastError || getErr;
        }
      }
    }

    if (i < retryDelaysMs.length) {
      await sleep(retryDelaysMs[i]);
    }
  }

  throw lastError || new Error('Wallet card was not issued');
}

export async function fetchWalletCardWithRetry({
  fetchCard,
  sleep = defaultSleep,
  retryDelaysMs = WALLET_RETRY_DELAYS_MS,
}) {
  let lastError = null;
  const attempts = retryDelaysMs.length + 1;

  for (let i = 0; i < attempts; i += 1) {
    try {
      return await fetchCard();
    } catch (err) {
      lastError = err;
      if (!isRetryableRequestError(err)) {
        throw err;
      }
    }
    if (i < retryDelaysMs.length) {
      await sleep(retryDelaysMs[i]);
    }
  }

  throw lastError || new Error('Wallet card was not loaded');
}
